import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* This div adds spacing at the top to prevent overlap */}
      <div style={{ paddingBottom: "60px" }}></div>

      {/* Back Button in the Bottom Right */}
      <button
        onClick={() => navigate("/")}
        style={{
          position: "fixed",
          top: "10px", // Move to bottom
          right: "20px", // Move to right
          padding: "8px 16px", // Smaller size
          fontSize: "14px",
          backgroundColor: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
        }}
      >
        ← Back
      </button>
    </>
  );
};

export default BackButton;
